const SVK = {
    breakpoint: {
        'desktop-min': 1280,
        'tablet-max': 1279,
        'tablet-min': 768,
        'mobile-min': 767
    },
    checkBreakpoint: function () {
        const currentScreenWidth = window.innerWidth;
        if (currentScreenWidth < SVK.breakpoint['tablet-min']) {
            return 'mobile';
        } else if (currentScreenWidth < SVK.breakpoint['desktop-min']) {
            return 'tablet';
        } else {
            return 'desktop';
        }
    },
    makeFixedHtml: function () {
        $('html').addClass('fixed')
    },
    makeUnfixedHtml: function () {
        $('html').removeClass('fixed')
    },

    /**
     * Отправляет CRM ID авторизованного пользователя в GTM
     *
     * @param {Number} crmId
     */
    sendCRMIdToGTM: function ( crmId) {
        if (crmId === 0) {
            console.error('Unable to send CRM ID to GTM');
            return;
        }

        window.dataLayer = window.dataLayer || [];

        dataLayer.push({
            'event': 'Authorization',
            'AccountID': crmId
        });

        console.log('%c SAP: CRM ID #' + crmId + ' has been sent to GTM ', 'background: #082b6e; color: #fff');
    }
};
